import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.5 16.8846V15.3846H2.3077V7.92305C2.3077 6.57818 2.72276 5.38908 3.55287 4.35575C4.38301 3.32242 5.44872 2.66153 6.75 2.37308V1.75C6.75 1.40278 6.87142 1.10765 7.11425 0.864601C7.35708 0.621534 7.65195 0.5 7.99885 0.5C8.34575 0.5 8.64099 0.621534 8.88457 0.864601C9.12816 1.10765 9.24995 1.40278 9.24995 1.75V2.37308C10.5512 2.66153 11.6169 3.32242 12.4471 4.35575C13.2772 5.38908 13.6922 6.57818 13.6922 7.92305V15.3846H15.5V16.8846H0.5ZM7.99828 19.6923C7.50069 19.6923 7.0753 19.5153 6.7221 19.1613C6.3689 18.8073 6.1923 18.3817 6.1923 17.8846H9.80765C9.80765 18.3833 9.63048 18.8093 9.27615 19.1625C8.92182 19.5157 8.49586 19.6923 7.99828 19.6923ZM3.80765 15.3846H12.1923V7.92305C12.1923 6.76535 11.783 5.77721 10.9644 4.95863C10.1458 4.14003 9.15767 3.73073 7.99997 3.73073C6.84227 3.73073 5.85413 4.14003 5.03555 4.95863C4.21695 5.77721 3.80765 6.76535 3.80765 7.92305V15.3846Z",
		fill: "currentColor"
	})
});
export default SvgBell2;
